
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.334 7.42c-.048.108-.071.213-.133.286-.14.167-.286.335-.456.472-.49.396-.994.776-1.49 1.164-.403.316-.81.628-1.154 1.008-.135.15-.259.31-.371.476-.129.189-.133.389-.04.605.215.508.48.989.752 1.467a75.28 75.28 0 0 1 2.146 4.022c.124.253.21.525.31.789a.317.317 0 0 1 .02.086c.012.144-.055.227-.197.2a1.511 1.511 0 0 1-.453-.155c-.337-.19-.665-.395-.99-.605-1.05-.678-2.096-1.362-3.145-2.042a8.122 8.122 0 0 0-1.333-.723 2.378 2.378 0 0 0-1.118-.194c-.297.026-.57.12-.836.247-.476.227-.905.528-1.325.84-.842.623-1.677 1.255-2.517 1.88-.181.135-.373.256-.563.378-.075.048-.156.09-.24.12-.13.044-.217-.023-.198-.157.016-.109.05-.218.091-.322.222-.553.441-1.108.676-1.656.377-.879.77-1.752 1.15-2.63a5.16 5.16 0 0 0 .321-.973c.082-.392-.029-.702-.367-.921-.19-.123-.391-.227-.589-.336-.14-.078-.284-.15-.424-.229a1.956 1.956 0 0 1-.225-.146c-.225-.17-.212-.377.045-.493a11.5 11.5 0 0 1 .897-.352c.468-.161.942-.304 1.41-.46.176-.06.345-.133.517-.201a2.184 2.184 0 0 0 1.047-.857c.252-.386.473-.792.713-1.186.114-.186.23-.374.368-.543a.876.876 0 0 1 .31-.228c.22-.1.376-.054.521.135.094.122.172.256.252.387.147.242.287.49.439.73a.86.86 0 0 0 .59.399c.163.03.334.054.497.038.523-.05 1.044-.113 1.564-.185.815-.115 1.628-.247 2.444-.358.223-.03.453-.018.68-.01a.66.66 0 0 1 .271.075c.055.029.087.1.133.158z",
  fill: "#000"
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.334 7.42c-.048.108-.071.213-.133.286-.14.167-.286.335-.456.472-.49.396-.994.776-1.49 1.164-.403.316-.81.628-1.154 1.008-.135.15-.259.31-.371.476-.129.189-.133.389-.04.605.215.508.48.989.752 1.467a75.28 75.28 0 0 1 2.146 4.022c.124.253.21.525.31.789.011.027.017.057.02.086.012.144-.055.227-.197.2a1.511 1.511 0 0 1-.453-.155c-.337-.19-.665-.395-.99-.605-1.05-.678-2.096-1.362-3.145-2.042a8.122 8.122 0 0 0-1.333-.723 2.378 2.378 0 0 0-1.118-.194c-.297.026-.57.12-.836.247-.476.227-.905.528-1.325.84-.842.623-1.677 1.255-2.517 1.88-.181.135-.373.256-.563.378-.075.048-.156.09-.24.12-.13.044-.217-.023-.198-.157.016-.109.05-.218.091-.322.222-.553.441-1.108.676-1.656.377-.879.77-1.752 1.15-2.63.135-.314.25-.636.321-.973.082-.392-.029-.702-.367-.921-.19-.123-.391-.227-.589-.336-.14-.078-.284-.15-.424-.229a1.956 1.956 0 0 1-.225-.146c-.225-.17-.212-.377.045-.493.293-.13.594-.247.897-.352.468-.161.942-.304 1.41-.46.176-.06.345-.133.517-.201a2.184 2.184 0 0 0 1.047-.857c.252-.386.473-.792.713-1.186.114-.186.23-.374.368-.543a.876.876 0 0 1 .31-.228c.22-.1.376-.054.521.135.094.122.172.256.252.387.147.242.287.49.439.73a.86.86 0 0 0 .59.399c.163.03.334.054.497.038.523-.05 1.044-.113 1.564-.185.815-.115 1.628-.247 2.444-.358.223-.03.453-.018.68-.01a.66.66 0 0 1 .271.075c.055.029.087.1.133.158z\" fill=\"#000\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/star.508e7bb29dfeb8eaf36e272ea77a1515.svg"),
        {
          React: SvgStar,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      